import Item from "../../core/items/Item"
import { DungeonDto } from "../dungeon/DungeonDto"
import { SimpleItemProps } from "../inventory/items/SimpleItemProps"
import { DungeonsKeys } from "./DungeonsKeysData"

interface BossKeyItemProps {
    id: string
    data: DungeonsKeys
}

const BossKeyItem = (props: BossKeyItemProps) => {


    if(props.data.bkImg === "")
    return null;
    return <Item
        id={props.id}
        image={props.data.bkImg}
        title={props.data.dungeon + " boss key"}
        
    />
}

export default BossKeyItem

interface BossKeyItemReworkProps {
    dungeon: DungeonDto,
    setDungeon: (v: DungeonDto) => void
}

export const BossKeyItemRework = (props: BossKeyItemReworkProps) => {


    if(props.dungeon.imgBk === "")
        return null;
    return <Item
        id={props.dungeon.name + "BK"}
        image={props.dungeon.imgBk}
        title={props.dungeon.name + " boss key"}
        
    />
}

interface SimpleBossKeyItemProps extends SimpleItemProps {
    dungeon: DungeonDto,
}

export const SimpleBossKeyItem = (props: SimpleBossKeyItemProps) => {
     
}